import { render } from "./AndorraPage.vue?vue&type=template&id=65e23940&scoped=true"
import script from "./AndorraPage.vue?vue&type=script&lang=js"
export * from "./AndorraPage.vue?vue&type=script&lang=js"

import "./AndorraPage.vue?vue&type=style&index=0&id=65e23940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e23940"]])

export default __exports__